import { httpRequest } from "@services/http";
import { Budget } from "@models/budget.model";
import { BudgetSerializer } from "@models/serializers/budgetSerializer";

export class CommandListBudgets {
  async run(params?: {
    contract_id?: number;
    is_active?: boolean;
  }): Promise<Budget[]> {
    const query = new URLSearchParams();
    if (params?.contract_id != null) query.set("contract_id", String(params.contract_id));
    if (params?.is_active != null) query.set("is_active", String(params.is_active));

    const qs = query.toString();
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/budgets/${qs ? `?${qs}` : ""}`;

    try {
      const response = await httpRequest<any[]>(url, { method: "GET" });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching budgets:", error);
      throw error;
    }
  }

  deserialize(data: any[]): Budget[] {
    return BudgetSerializer.fromJsonList(data);
  }
}